import React, { useEffect, useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { QtcRenderer } from '@3plearning/question-components-library';
import { Box } from '@chakra-ui/react';
import css from './conquest.scss';
import Resources from '../../helpers/resources';
import { getLocale } from '../../helpers/locale';

const Conquest = ({ girlId }) => {
  const { id, version } = useSelector(state => state.UPFAssignReducer.selectedCourse);
  const [asyncError, setAsyncError] = useState(null);
  const [conquestData, setConquestData] = useState(null);

  const newContent = async () => {
    try {
      const response = await Resources.getSingleQuestion
        .get({
          id,
          version,
          girlId,
          locale: getLocale()
        })
        .send();
      if (response.data) {
        console.log('Conquest data:', response.data);
        setConquestData({
          ...response.data,
          sectionResults: Object.entries(response.data.primaryAnswer).reduce((result, [sectionId, sectionAnswer]) => {
            if (typeof sectionAnswer === 'object') {
              if (Array.isArray(sectionAnswer)) {
                return {
                  ...result,
                  [sectionId]: Array(sectionAnswer.length).fill(true)
                };
              }
              return {
                ...result,
                [sectionId]: Object.entries(sectionAnswer).reduce((graphResult, [graphTool, graphAnswer]) => ({
                  ...graphResult,
                  [graphTool]: Array(graphAnswer.length).fill(true)
                }), {})
              };
            }
            return {
              ...result,
              [sectionId]: true
            };
          }, {})
        });
      } else {
        setAsyncError('No data found');
      }
    } catch (error) {
      setAsyncError('No data found');
    }
  };

  useEffect(() => {
    newContent();

    return () => {
      setConquestData(null);
      setAsyncError(null);
    };
  }, []);

  return (
    <Box className={css['qtc-container']}>
      {
        conquestData ? (
          <QtcRenderer
            question={conquestData.question.questionVariant.questionItem.questionContent.content}
            callback={() => null}
            validation={{
              isCorrect: true,
              validAnswer: conquestData.primaryAnswer,
              sectionResults: conquestData.sectionResults
            }}
            userResponse={conquestData.primaryAnswer}
          />
        ) : (
          <Fragment>
            {asyncError || 'Loading...'}
          </Fragment>
        )
      }
    </Box>
  );
};

Conquest.propTypes = {
  girlId: PropTypes.string
};

export default Conquest;
